module.exports = __webpack_public_path__ + "static/img/cart1.f99cf8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart1.png
// module id = dEc5
// module chunks = 2